/**
 * URL do publicznych plików (Storage) – np. hero-background1.png, pins1.png.
 * Używane w kolejności: REACT_APP_STORAGE_PUBLIC_BASE_URL, potem REACT_APP_SUPABASE_URL.
 * Sam URL projektu Supabase (https://xxx.supabase.co) nie jest kluczem – możesz go mieć w Vercel dla grafik.
 */
export const storagePublicBaseUrl =
  process.env.REACT_APP_STORAGE_PUBLIC_BASE_URL ||
  process.env.REACT_APP_SUPABASE_URL ||
  '';
